var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((Object.keys(_vm.leaderboardsData)),function(leaderboard){return _c('v-card',{key:leaderboard,staticClass:"pa-2 mt-4 text-xs-center",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.openSelectedLeaderboard(leaderboard)}}},[_vm._v(_vm._s(_vm.leaderboardsData[leaderboard].displayName))])}),_c('v-dialog',{attrs:{"max-width":"600px","fullscreen":"","hide-overlay":""},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('div',[_c('div',{staticClass:"header",style:({
					backgroundColor: _vm.themeInputColor
				})},[_c('v-btn',{staticClass:"top-left-align pa-0 ma-0 z-index--2",attrs:{"fab":"","flat":"","icon":""},on:{"click":function($event){_vm.showDialog = false}}},[_c('v-icon',{attrs:{"color":"#FFF"}},[_vm._v("arrow_back")])],1),_vm._v("\n\t\t\t\t"+_vm._s(_vm.selectedLeaderboardData.displayName)+"\n\t\t\t")],1),_c('v-card',{staticClass:"card",attrs:{"min-height":"100vh"}},[(
						(_vm.selectedLeaderboardData.rankList || []).length > 0
					)?_c('div',{staticStyle:{"min-width":"50vh"}},[_c('v-layout',{attrs:{"d-flex":"","justify-space-around":"","pb-4":""}},_vm._l((_vm.getFirstThreeRank),function(item,index){return _c('v-layout',{key:index,staticStyle:{"flex":"1 !important"},style:([
								{
									order:
										(
											_vm.selectedLeaderboardData.rankList ||
											[]
										).length > 2
											? index === 0
												? 15
												: index * 10
											: 1
								}
							]),attrs:{"justify-end":"","align-center":"","column":""}},[_c('div',{staticClass:"outerCircle",class:{
									darkBorder: item.userId === _vm.userId
								}},[_c('v-avatar',{attrs:{"size":index === 0 ? '80' : '60'}},[_c('div',{staticClass:"imageCircle",style:([
											{
												background: _vm.getHeadOnUserBackgroundColor(
													item.userId
												)
											}
										])},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s((item.retailerName &&
												item.retailerName
													.charAt(0)
													.toUpperCase()) ||
												"-")+"\n\t\t\t\t\t\t\t\t\t")])]),_c('div',{staticClass:"smallCircle"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(item.rank)+"\n\t\t\t\t\t\t\t\t")])],1),_c('div',{staticClass:"body-1 ellipsis text-center",staticStyle:{"width":"100%"}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(item.retailerName)+"\n\t\t\t\t\t\t\t")]),_c('div',{staticClass:"greenText"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(item.value)+"\n\t\t\t\t\t\t\t")])])}),1),(
							(_vm.selectedLeaderboardData.rankList || [])
								.length > 0
						)?_c('div',{staticClass:"tableContainer"},[_c('div',{staticClass:"tableHeader"},[_c('div',{staticStyle:{"min-width":"200px"}},[_vm._v("Rank")]),_c('div',{staticStyle:{"display":"flex","justify-content":"space-around","min-width":"600px"}},[_c('div',[_vm._v("Value")]),_c('div',[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.isPrizeExist ? "Prize" : "")+"\n\t\t\t\t\t\t\t\t")]),_c('div',[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.isPrizeExist ? "Image" : "")+"\n\t\t\t\t\t\t\t\t")])])]),(_vm.getSelfEntry.length > 0)?_c('v-card',[_c('div',{staticClass:"listEntry"},[_c('div',{staticClass:"entryRank"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.getSelfEntry[0].rank)+"\n\t\t\t\t\t\t\t\t")]),_c('div',{staticClass:"entryImage"},[_c('v-avatar',{attrs:{"size":50}},[_c('div',{staticClass:"imageCircle",style:([
												{
													background: _vm.getHeadOnUserBackgroundColor(
														_vm.getSelfEntry[0]
															.userId
													)
												}
											])},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s((
													_vm.getSelfEntry[0]
														.retailerName || "-"
												).length > 0
													? _vm.getSelfEntry[0]
															.retailerName &&
													  _vm.getSelfEntry[0].retailerName
															.charAt(0)
															.toUpperCase()
													: "-")+"\n\t\t\t\t\t\t\t\t\t\t")])])],1),_c('div',[_c('div',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.getSelfEntry[0].retailerName)+"\n\t\t\t\t\t\t\t\t\t")])]),_c('div',{staticClass:"entryInfo"},[_c('div',{staticClass:"entryValue"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.getSelfEntry[0].value)+"\n\t\t\t\t\t\t\t\t\t")]),_c('div',{staticClass:"entryValue"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.isPrizeExist
												? (
														_vm.getSelfEntry[0]
															.prize || {}
												  ).prize || "-"
												: "")+"\n\t\t\t\t\t\t\t\t\t")]),_c('div',{staticClass:"entryValue"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.isPrizeExist
												? (
														_vm.getSelfEntry[0]
															.prize || {}
												  ).image || "-"
												: "")+"\n\t\t\t\t\t\t\t\t\t")])])])]):_vm._e(),_c('div',_vm._l((_vm.selectedLeaderboardData.rankList),function(item){return _c('v-card',{key:item.userId},[(
										item.userId !== _vm.userId &&
											item.userId
									)?_c('div',{key:item.userId,staticClass:"listEntry"},[_c('div',{staticClass:"entryRank"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(item.rank)+"\n\t\t\t\t\t\t\t\t\t")]),_c('div',{staticClass:"entryImage"},[_c('v-avatar',{attrs:{"size":50}},[_c('div',{staticClass:"imageCircle",style:([
													{
														background: _vm.getHeadOnUserBackgroundColor(
															item.userId
														)
													}
												])},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s((
														item.retailerName ||
														"-"
													).length > 0
														? item.retailerName &&
														  item.retailerName
																.charAt(0)
																.toUpperCase()
														: "-")+"\n\t\t\t\t\t\t\t\t\t\t\t")])])],1),_c('div',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(item.retailerName)+"\n\t\t\t\t\t\t\t\t\t")]),_c('div',{staticClass:"entryInfo"},[_c('div',{staticClass:"entryValue"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(item.value)+"\n\t\t\t\t\t\t\t\t\t\t")]),(_vm.isPrizeExist)?_c('div',{staticClass:"entryValue"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s((item.prize || {}).prize ||
													"-")+"\n\t\t\t\t\t\t\t\t\t\t")]):_vm._e(),(_vm.isPrizeExist)?_c('div',{staticClass:"entryValue"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s((item.prize || {}).image ||
													"-")+"\n\t\t\t\t\t\t\t\t\t\t")]):_vm._e()])]):_vm._e()])}),1)],1):_vm._e()],1):_vm._e()])],1)]),(_vm.isDataLoading)?_c('div',{staticClass:"overlay"},[_c('v-progress-circular',{attrs:{"indeterminate":true}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }